import { render, staticRenderFns } from "./PelleBarPanel.vue?vue&type=template&id=27bab1a5&scoped=true&"
import script from "./PelleBarPanel.vue?vue&type=script&lang=js&"
export * from "./PelleBarPanel.vue?vue&type=script&lang=js&"
import style0 from "./PelleBarPanel.vue?vue&type=style&index=0&id=27bab1a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bab1a5",
  null
  
)

export default component.exports